// Third-party packages
import {
	Address,
	AddressJson,
} from '@@types/Address';
import {
	APP_CONF_VARS,
} from '@appConf/vars.conf';
import {
	closest,
	distance,
} from 'fastest-levenshtein';

interface currencyMappingProps {
	[key: string]: string;
}

export const capitalize = (text: string) => text?.length ? text.charAt(0).toUpperCase() + text.slice(1) : '';
export const cleanData = (text: string) => text.replace(/[\t\n]/g, '');

export const stripHtml = (html: string) => {
	const tmp = document.createElement('DIV');
	tmp.innerHTML = html;
	const result = tmp.textContent || tmp.innerText || '';
	return result;
};

export const normalizeText = (text: string) => text
	.normalize('NFD')
	.replace(/[\u0300-\u036f]/g, '')
	.replace(/[^a-zA-Z0-9\s]/g, '')
	.toLowerCase();

export const getLevenshteinDistance = (string1: string, string2: string) => distance(string1.toLowerCase(), string2.toLowerCase());

export const getLevenshteinClosest = (string1: string, otherStrings: string[]) => closest(string1, otherStrings);

export const isWordCloseAtLeastOneWordFromWordlist = (firstString: string, wordsList: string[]) => {
	let isClose = false;
	let distance = 99;
	const isLongString = firstString.length >= APP_CONF_VARS.levenshtein.long.minLength;
	const maxDistance = APP_CONF_VARS.levenshtein[isLongString ? 'long' : 'small'].distance;

	const wordListWithoutIgnoredWords = wordsList.filter((word: string) => word.length > APP_CONF_VARS.levenshtein.ignoreLength);
	wordListWithoutIgnoredWords.forEach((word: string) => {
		if (!isClose) {
			distance = getLevenshteinDistance(firstString, word);
			if (distance <= maxDistance) {
				isClose = true;
			}
		}
	});
	return isClose;
};

export const format = (rawValue: AddressJson | number | string, dataType: string, lng?: string) => {
	const language = lng ? lng : 'fr-FR';

	const getCurrencyDOM = () => {
		const currencyMapping = {
			'en-GB': 'GBP',
			'fr-FR': 'EUR',
		} as currencyMappingProps;

		const currencyFormated = new Intl.NumberFormat(language, {
			currency: currencyMapping[language],
			minimumFractionDigits: 0,
			style: 'currency',
		});

		const numberString = currencyFormated.formatToParts(rawValue as number).map(({
			type, value,
		}, index) => (
			<span
				key={index}
				{...{
					[`data-${type}`]: true,
				}}
			>
				{value}
			</span>
		));

		return isNaN(rawValue as number) ? rawValue : <span data-currency>{numberString}</span>;
	};

	switch (dataType) {
		case 'address': {
			const newAddress = new Address(rawValue as AddressJson);
			return newAddress.full;
		}
		case 'currency': {
			return getCurrencyDOM();
		}
		default:
			return cleanData(rawValue as string);
	}
};
